import { render } from "./App.vue?vue&type=template&id=05a71a5c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=05a71a5c&lang=css"
script.render = render

export default script